import React from 'react'
import styles from './index.module.css'

import classnames from 'classnames'

const Bubble = ({ children, top, bottom }) => {
  return (
    <div
      className={classnames(styles.Bubble, {
        [styles.top]: top,
        [styles.bottom]: bottom,
      })}
    >
      {children}
    </div>
  )
}

export default Bubble
